import style from "./AddStyle"

export default function Add() {

    return (
        <div style={style.addContainer}>
            Aqui vai nossas putarias
            Aqui vai nossas putarias
            Aqui vai nossas putarias
        </div>
    )
}

